import React from 'react';

interface IChevronRightIcon {
  width?: string;
  height?: string;
  fillColor?: string;
}
const ChevronRightIcon = ({ width, height, fillColor }: IChevronRightIcon) => {
  return (
    <svg
      width={width || '16'}
      height={height || '16'}
      viewBox="0 0 16 16"
      fill={fillColor || 'none'}
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.305 4.98875C6.11433 5.1885 6.12169 5.50499 6.32144 5.69566L8.73619 8.00065L6.32144 10.3056C6.12169 10.4963 6.11433 10.8128 6.305 11.0126C6.49567 11.2123 6.81217 11.2197 7.01191 11.029L9.80557 8.36233C9.90441 8.26798 9.96033 8.13729 9.96033 8.00065C9.96033 7.86401 9.90441 7.73332 9.80557 7.63897L7.01191 4.97231C6.81217 4.78164 6.49567 4.789 6.305 4.98875Z"
        fill={fillColor || '#5941A9'}
      />
    </svg>
  );
};

export default ChevronRightIcon;
